var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-number", {
    ref: "discount",
    attrs: {
      disabled: _vm.isDisabled,
      label: _vm.$ct("sales-row.Discount"),
      icon: _vm.icon,
      fancy: "",
    },
    on: {
      "icon-click": function ($event) {
        return _vm.onIconClick()
      },
      keydown: function ($event) {
        return _vm.$emit("keydown", $event)
      },
      keyup: [
        function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.$emit("blur", $event)
        },
        function ($event) {
          return _vm.$emit("keyup", $event)
        },
      ],
    },
    model: {
      value: _vm.state.discount,
      callback: function ($$v) {
        _vm.$set(_vm.state, "discount", $$v)
      },
      expression: "state.discount",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }